module.exports = __webpack_public_path__ + "src/img/artist/artist01_dream.jpg?5ead9719b1e151356c2cfbf4d7959c22";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artist01_dream.jpg
// module id = 108
// module chunks = 0